import { render, staticRenderFns } from "./OpenTicketingBlock.vue?vue&type=template&id=513dc5fa"
import script from "./OpenTicketingBlock.vue?vue&type=script&lang=js"
export * from "./OpenTicketingBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports